<div class="login-page">
    <div class="login-container">
        <div class="login-image-col">
            <img src="assets/images/call-man.svg" alt="Security Call Center" class="login-image">
        </div>
        <div class="login-card">
            <div class="login-header">
                <h1>Se connecter</h1>
            </div>

            <form class="login-form" #loginForm="ngForm" (ngSubmit)="onLogin(loginForm)">
                <div class="form-group">
                    <div class="input-group">
                        <img src="assets/images/icons/user-red.png" alt="user-icon" class="input-icon user-icon">
                        <input type="text" id="usernameOrEmail" name="usernameOrEmail" [(ngModel)]="loginRequest.usernameOrEmail" #usernameOrEmail="ngModel" required placeholder="Entrez votre email" [class.error]="usernameOrEmail.invalid && usernameOrEmail.touched">
                    </div>
                    <div *ngIf="usernameOrEmail.invalid && usernameOrEmail.touched" class="form_error">
                        L'email est requis
                    </div>
                </div>

                <!-- Password Field -->
                <div class="form-group">
                    <div class="input-group">
                        <img src="assets/images/icons/lock-red.png" alt="lock-icon" class="input-icon">
                        <input [type]="showPassword ? 'text' : 'password'" id="password" name="password" [(ngModel)]="loginRequest.password" #password="ngModel" required placeholder="Entrez votre mot de passe" [class.error]="password.invalid && password.touched">
                        <button type="button" class="password-toggle" (click)="togglePassword()">
                            <img src="assets/images/icons/eye.png" alt="eye-icon">
                        </button>
                    </div>
                    <div *ngIf="password.invalid && password.touched" class="form_error">
                        Le mot de passe est requis
                    </div>
                </div>

                <!-- Error Message -->
                <div *ngIf="errorMessage" class="alert alert-error py-2 px-1">
                    <div>
                        <span class="form_error"> {{ errorMessage }}</span>
                    </div>
                    <div *ngIf="emailNotVerified" class="verification-actions">
                        <button type="button" class="link-button" (click)="resendVerification()">
                        Renvoyer le lien de vérification
                    </button>
                        <span>ou</span>
                        <button type="button" class="link-button" (click)="navigateToResendVerification()">
                        Utiliser une autre adresse email
                    </button>
                    </div>
                </div>

                <!-- Links -->
                <div class="login-links">
                    <a [routerLink]="['/forgot-password']" class="link">Mot de passe oublié?</a>
                    <!--<a [routerLink]="['/register']" class="link">Créer un compte</a>-->
                </div>

                <!-- Submit Button -->
                <button type="submit" class="login-btn" [disabled]="isLoading" [class.loading]="isLoading">
                    <span *ngIf="!isLoading">Se connecter</span>
                    <span *ngIf="isLoading">Connexion...</span>
                </button>



                <div class="register-links">
                    <h3>Pas encore membre ?</h3>
                    <a [routerLink]="['/register']" class="link">Créer un compte</a>
                </div>
            </form>
        </div>
    </div>
</div>